<template>
  <div class="independent-wrapper">
    <div class="content">
      <div class="title">
        <span class="border"></span>
        <i class="el-icon-location-outline"></i> 商城管理 > 佣金配置
      </div>
      <div class="contentLeft">
        <div class="con">
          <div class="version">
            <el-button class="addBtn" style="color: #fff;" @click="openDialog('add')">新增城市配置</el-button>
          </div>
          <div class="table-con consiliaTable">
            <el-table
              ref="multipleTable"
              :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
              tooltip-effect="dark"
              style="width: 100%"
              :data="tableData"
              v-loading="loading"
            >
              <el-table-column align="center" label="城市" prop="cityName" width="120">
                <template #default="{ row }">
                  {{ row.cityCode ? row.cityName : '全局默认' }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="城市代理" prop="cityAgentRate" width="100">
                <template #default="{ row }">{{ formatRate(row.cityAgentRate) }}</template>
              </el-table-column>
              <el-table-column align="center" label="区县代理" prop="districtAgentRate" width="100">
                <template #default="{ row }">{{ formatRate(row.districtAgentRate) }}</template>
              </el-table-column>
              <el-table-column align="center" label="经销商" prop="dealerRate" width="100">
                <template #default="{ row }">{{ formatRate(row.dealerRate) }}</template>
              </el-table-column>
              <el-table-column align="center" label="平台" prop="platformRate" width="90">
                <template #default="{ row }">{{ formatRate(row.platformRate) }}</template>
              </el-table-column>
              <el-table-column align="center" label="推荐L1" prop="referralL1Rate" width="90">
                <template #default="{ row }">{{ formatRate(row.referralL1Rate) }}</template>
              </el-table-column>
              <el-table-column align="center" label="推荐L2" prop="referralL2Rate" width="90">
                <template #default="{ row }">{{ formatRate(row.referralL2Rate) }}</template>
              </el-table-column>
              <el-table-column align="center" label="城市推荐L1" prop="cityReferralL1Rate" width="110">
                <template #default="{ row }">{{ formatRate(row.cityReferralL1Rate) }}</template>
              </el-table-column>
              <el-table-column align="center" label="城市推荐L2" prop="cityReferralL2Rate" width="110">
                <template #default="{ row }">{{ formatRate(row.cityReferralL2Rate) }}</template>
              </el-table-column>
              <el-table-column align="center" label="状态" prop="status" width="80">
                <template #default="{ row }">
                  <span :style="{ color: row.status === 1 ? '#67c23a' : '#f56c6c' }">
                    {{ row.status === 1 ? '启用' : '禁用' }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="更新时间" prop="modifyTime" width="160">
              </el-table-column>
              <el-table-column align="center" label="操作" width="140">
                <template #default="{ row }">
                  <span class="editor" @click="openDialog('edit', row)">编辑</span>
                  <span class="del" v-if="row.cityCode" @click="handleDelete(row)">删除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogMode === 'add' ? '新增佣金配置' : '编辑佣金配置'"
      v-model="dialogVisible"
      width="600px"
      center
    >
      <el-form ref="configForm" :model="formData" :rules="formRules" label-width="130px">
        <el-form-item label="城市编码" prop="cityCode">
          <el-input v-model="formData.cityCode" placeholder="留空为全局默认" :disabled="dialogMode === 'edit'"></el-input>
        </el-form-item>
        <el-form-item label="城市名称" prop="cityName">
          <el-input v-model="formData.cityName" placeholder="如：杭州市"></el-input>
        </el-form-item>
        <el-form-item label="城市代理佣金" prop="cityAgentRate">
          <el-input-number v-model="formData.cityAgentRate" :min="0" :max="1" :step="0.01" :precision="4"></el-input-number>
          <span class="rate-hint">{{ formatRate(formData.cityAgentRate) }}</span>
        </el-form-item>
        <el-form-item label="区县代理佣金" prop="districtAgentRate">
          <el-input-number v-model="formData.districtAgentRate" :min="0" :max="1" :step="0.01" :precision="4"></el-input-number>
          <span class="rate-hint">{{ formatRate(formData.districtAgentRate) }}</span>
        </el-form-item>
        <el-form-item label="经销商佣金" prop="dealerRate">
          <el-input-number v-model="formData.dealerRate" :min="0" :max="1" :step="0.01" :precision="4"></el-input-number>
          <span class="rate-hint">{{ formatRate(formData.dealerRate) }}</span>
        </el-form-item>
        <el-form-item label="平台佣金" prop="platformRate">
          <el-input-number v-model="formData.platformRate" :min="0" :max="1" :step="0.01" :precision="4"></el-input-number>
          <span class="rate-hint">{{ formatRate(formData.platformRate) }}</span>
        </el-form-item>
        <el-form-item label="推荐奖励L1" prop="referralL1Rate">
          <el-input-number v-model="formData.referralL1Rate" :min="0" :max="1" :step="0.01" :precision="4"></el-input-number>
          <span class="rate-hint">{{ formatRate(formData.referralL1Rate) }}</span>
        </el-form-item>
        <el-form-item label="推荐奖励L2" prop="referralL2Rate">
          <el-input-number v-model="formData.referralL2Rate" :min="0" :max="1" :step="0.01" :precision="4"></el-input-number>
          <span class="rate-hint">{{ formatRate(formData.referralL2Rate) }}</span>
        </el-form-item>
        <el-form-item label="城市推荐L1" prop="cityReferralL1Rate">
          <el-input-number v-model="formData.cityReferralL1Rate" :min="0" :max="1" :step="0.01" :precision="4"></el-input-number>
          <span class="rate-hint">{{ formatRate(formData.cityReferralL1Rate) }}</span>
        </el-form-item>
        <el-form-item label="城市推荐L2" prop="cityReferralL2Rate">
          <el-input-number v-model="formData.cityReferralL2Rate" :min="0" :max="1" :step="0.01" :precision="4"></el-input-number>
          <span class="rate-hint">{{ formatRate(formData.cityReferralL2Rate) }}</span>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="formData.status" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="禁用"></el-switch>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axiosconf from '../../api/axiosconf'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      dialogVisible: false,
      dialogMode: 'add',
      submitting: false,
      formData: this.getDefaultForm(),
      formRules: {
        cityAgentRate: [{ required: true, message: '请输入城市代理佣金比例', trigger: 'blur' }],
        districtAgentRate: [{ required: true, message: '请输入区县代理佣金比例', trigger: 'blur' }],
        dealerRate: [{ required: true, message: '请输入经销商佣金比例', trigger: 'blur' }],
        platformRate: [{ required: true, message: '请输入平台佣金比例', trigger: 'blur' }],
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    getDefaultForm() {
      return {
        id: null,
        cityCode: '',
        cityName: '',
        cityAgentRate: 0.05,
        districtAgentRate: 0.10,
        dealerRate: 0.30,
        platformRate: 0.05,
        referralL1Rate: 0.02,
        referralL2Rate: 0.01,
        cityReferralL1Rate: 0.05,
        cityReferralL2Rate: 0.03,
        calcMode: 1,
        status: 1
      }
    },
    formatRate(val) {
      if (val === null || val === undefined) return '--'
      return (parseFloat(val) * 100).toFixed(2) + '%'
    },
    async fetchList() {
      this.loading = true
      try {
        const res = await axiosconf.applicationJson('/mall/admin/commission/config/list')
        if (res.data && res.data.code === 0) {
          this.tableData = res.data.data || []
        }
      } catch (e) {
        console.error('获取佣金配置失败', e)
      } finally {
        this.loading = false
      }
    },
    openDialog(mode, row) {
      this.dialogMode = mode
      if (mode === 'edit' && row) {
        this.formData = { ...row }
      } else {
        this.formData = this.getDefaultForm()
      }
      this.dialogVisible = true
    },
    async handleSubmit() {
      this.$refs.configForm.validate(async (valid) => {
        if (!valid) return
        this.submitting = true
        try {
          const url = this.dialogMode === 'add'
            ? '/mall/admin/commission/config/add'
            : '/mall/admin/commission/config/edit'
          const res = await axiosconf.applicationJson(url, this.formData)
          if (res.data && res.data.code === 0) {
            this.$message.success(this.dialogMode === 'add' ? '新增成功' : '编辑成功')
            this.dialogVisible = false
            this.fetchList()
          } else {
            this.$message.error(res.data.msg || '操作失败')
          }
        } catch (e) {
          this.$message.error('请求失败')
        } finally {
          this.submitting = false
        }
      })
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定删除该城市佣金配置？', '提示', { type: 'warning' })
        const res = await axiosconf.applicationJson(`/mall/admin/commission/config/delete/${row.id}`)
        if (res.data && res.data.code === 0) {
          this.$message.success('删除成功')
          this.fetchList()
        } else {
          this.$message.error(res.data.msg || '删除失败')
        }
      } catch (e) {
        // 用户取消
      }
    }
  }
}
</script>

<style scoped>
.independent-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.content {
  padding: 20px;
}
.title {
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;
}
.title .border {
  display: inline-block;
  width: 3px;
  height: 14px;
  background: #679FF6;
  margin-right: 8px;
  vertical-align: middle;
}
.version {
  margin-bottom: 16px;
  overflow: hidden;
}
.addBtn {
  float: right;
  background: #679FF6;
  border-color: #679FF6;
}
.editor {
  color: #679FF6;
  cursor: pointer;
  margin-right: 10px;
}
.del {
  color: #f56c6c;
  cursor: pointer;
}
.rate-hint {
  margin-left: 8px;
  color: #999;
  font-size: 12px;
}
</style>
